import { cropSelector } from "store/features/crop/selectors/cropSelector";
import { CropState } from "store/features/crop/types";
import { useAppSelector } from "store/store";

export const useLeft = () => {
    const {
        crop: { left },
    } = useAppSelector(cropSelector, equalityFn);

    return { left };
};

const equalityFn = (left: CropState, right: CropState) => {
    if (left.crop.left !== right.crop.left) return false;

    return true;
};
